import { createPDFViewer } from "./pdfv1";

// ==================== 使用示例 ====================

window.addEventListener("DOMContentLoaded", function () {
  console.log("DOMContentLoaded");

  // 创建 PDF 查看器实例
  const pdfViewer = createPDFViewer({
    url: "2020-Scrum-Guide-Chinese-Simplified.pdf",
    canvas: "#pdf-canvas",
    workerSrc: "../../assets/pdf/v1.10.100/pdf.worker.min.js",
    scale: 1.5,
    initialPage: 1,
    onPageRendered: (page, total) => {
      console.log(`页面 ${page}/${total} 渲染完成`);
      // 更新页码显示
      const pageInfo = document.getElementById("pdf-page-info");
      if (pageInfo) {
        pageInfo.textContent = `${page} / ${total}`;
      }
      // 更新按钮状态
      const prevBtn = document.getElementById("pdf-prev") as HTMLButtonElement;
      const nextBtn = document.getElementById("pdf-next") as HTMLButtonElement;
      if (prevBtn) {
        prevBtn.disabled = page <= 1;
      }
      if (nextBtn) {
        nextBtn.disabled = page >= total;
      }
    },
    onLoaded: (total) => {
      console.log(`PDF 加载完成，共 ${total} 页`);
    },
    onError: (error) => {
      console.error("PDF 错误:", error);
    },
  });

  // 外部绑定事件
  const prevBtn = document.getElementById("pdf-prev");
  const nextBtn = document.getElementById("pdf-next");

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      pdfViewer.prev();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      pdfViewer.next();
    });
  }

  // 也可以手动控制
  // pdfViewer.next();
  // pdfViewer.prev();
  // pdfViewer.goToPage(5);
  // console.log(pdfViewer.getCurrentPage());
  // console.log(pdfViewer.getTotalPages());
});
